// src/components/Templates/TemplatePreview.jsx
/**
 * Componente para preview visual de um template de WhatsApp.
 * Mostra header, body, footer e botões em formato de mensagem.
 */

import React from "react";
import "./Templates.css";

const TemplatePreview = ({
  template,
  variableValues = {},
  showRaw = false,
}) => {
  if (!template) {
    return (
      <div className="template-preview-empty">
        Selecione um template para visualizar
      </div>
    );
  }

  // Substituir variáveis no texto
  const replaceVariables = (text, values) => {
    if (!text) return "";

    let result = text;

    // Substituir {{1}}, {{2}}, etc.
    Object.entries(values).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, "g");
      result = result.replace(regex, value || `[${key}]`);
    });

    // Destacar variáveis não substituídas
    result = result.replace(
      /\{\{\s*(\d+)\s*\}\}/g,
      '<span class="template-variable-placeholder">{{$1}}</span>'
    );

    return result;
  };

  const headerText = template.header_text || template.headerText || "";
  const bodyText = template.body_text || template.bodyText || "";
  const footerText = template.footer_text || template.footerText || "";
  const buttons = template.buttons || [];

  const processedHeader = showRaw ? headerText : replaceVariables(headerText, variableValues);
  const processedBody = showRaw ? bodyText : replaceVariables(bodyText, variableValues);
  const processedFooter = showRaw ? footerText : replaceVariables(footerText, variableValues);

  return (
    <div className="template-preview">
      <div className="template-preview-header-info">
        <h4 className="template-preview-name">{template.name}</h4>
        <div className="template-preview-meta">
          <span className={`template-status-badge template-status-${template.status?.toLowerCase()}`}>
            {template.status}
          </span>
          <span className="template-preview-category">{template.category}</span>
          <span className="template-preview-language">{template.language}</span>
        </div>
      </div>

      <div className="template-preview-message">
        {/* Header */}
        {headerText && (
          <div
            className="template-preview-section template-preview-header-text"
            dangerouslySetInnerHTML={{ __html: processedHeader }}
          />
        )}

        {/* Body */}
        {bodyText && (
          <div
            className="template-preview-section template-preview-body"
            dangerouslySetInnerHTML={{ __html: processedBody }}
          />
        )}

        {/* Footer */}
        {footerText && (
          <div
            className="template-preview-section template-preview-footer"
            dangerouslySetInnerHTML={{ __html: processedFooter }}
          />
        )}

        {/* Buttons */}
        {buttons.length > 0 && (
          <div className="template-preview-buttons">
            {buttons.map((button, idx) => (
              <div key={idx} className="template-preview-button">
                {button.text || button.label || `Button ${idx + 1}`}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Lista de variáveis */}
      {template.variables && template.variables.length > 0 && (
        <div className="template-preview-variables-info">
          <strong>Variáveis do template:</strong>
          <ul className="template-variables-list">
            {template.variables.map((variable, idx) => (
              <li key={idx} className="template-variable-item">
                <code>{`{{${variable.key || variable}}}`}</code>
                {variable.hint && (
                  <span className="template-variable-hint"> - {variable.hint}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
